export const STORAGE_CONFIG = {
    LOCAL_STORAGE: {
        ISCREDITNEWADDRESS: 'isCreditNewAddress',
        VIEWCART: 'viewCart',
        COMPANYID: 'companyID',
        GUID: 'guid',
        ISCHECKOUTLOADING: 'isCheckoutLoading',
        PROJECTDETAILS: 'projectDetails',
        ISINSTOREPICKUP: 'isInStorePickup',
        CHECKOUTREFERRER: 'checkoutReferrer',
        USER_LOGIN: 'user-login',
        FIRSTNAME: 'firstName',
        YOURDETAILS: 'yourDetails',
        SELECTEDSTOREDETAILS: 'selectedStoreDetails',
        JOBSITE_SEARCH_KEYWORD: 'jobsiteSearchKeyword',
        SELECTED_ACCOUNT_ID: 'selectedAccountId',
        IP_ADDRESS: 'ipAddress',
        CARTTOTALQUANTITY: 'cartTotalQuantity',
        ISNEWADDRESSONOVERLAY: 'isNewAddressOnOverlay',
        CJDLVY: 'CJDLVY',
        FOURHOURRENTALS: 'fourHourRentals',
        SHOWEDITQUOTEBANNER: 'showEditQuoteBanner',
        TRANSMITTED_QUOTE_ID: 'transmittedQuoteId',
        DISPLAY_QUOTE_ID: 'displayQuoteId',
        STARTDATE: 'startDate',
        ENDDATE: 'endDate',
        LOCALSELECTEDSTOREDETAILS: 'localSelectedStoreDetails',
        LOCATIONSEARCHFIELDS: 'locationSearchFields',
        CORP_ACCOUNT_DETAILS: 'corpAccountDetails',
        ISCREATEJOBSITE: 'isCreateJobsite',
        FIRST_LOCATION_STORE: 'firstLocationStore'
    },
    SESSION_STORAGE: {
        USERPROFILE: 'userProfile',
        MKTOLOGGEDIN: 'mktoLoggedIn',
        OVERRIDEPC: 'overridePc',
        SBMID: 'sbmid',
        SBSID: 'sbsid',
        CIF_MAGENTOTOKEN: 'cif.magentoToken',
        ISADDONVISIBLE: 'isAddOnVisible',
        CARTCONTEXT: 'cartContext',
        PAYMENTSTEP: 'paymentStep',
        FORMSTEP: 'formStep',
        LOCATIONPCOBJ: 'locationPCObj',
        ANALYSISREGION: 'analysisRegion',
        SOURCEPCOBJ: 'sourcePCObj',
        HOMEASSETSRATES: 'homeAssetsRates',
        PROJECTLOADINGTIMERID: 'projectLoadingTimerId',
        MARKETOFEED: 'marketoFeed',
        ISUSERPRESUBSCRIBED: 'isUserPreSubscribed',
        ISSOURCESLOADING: 'isSourcesLoading',
        ISLOCATIONFORMNOTDIRTY: 'ISLOCATIONFORMNOTDIRTY',
        ISJOBSITESFETCHED: 'isJobsitesFetched',
        RECOMMENDED_JOBSITE: 'recommendedJobsite',
        ORDER_ESTIMATES_FINAL_TOTAL: 'orderEstimatesFinalTotal',
        IS_SOURCES_TIER_2_RADIUS: 'isSourcesTier2Radius',
        IS_LOCATIONS_TIER_2_RADIUS: 'isLocationsTier2Radius',
        IS_CART_UPDATED_WITH_PRICE: 'isCartUpdatedWithPrice',
        USERTYPE: 'userType',
        ESTIMATES_PICKUP: 'estimatePickup',
        ESTIMATES_DELIVERY: 'estimateDelivery',
        CHECKOUT_CURRENT_STEP: 'currentStep',
        USER_DATA_OBJ: 'userDataObj',
        CID_PC_LIST: 'cidPcList',
        ATP_PC_LIST: 'atpPcList',
        SELECTEDSTOREDETAILS_FOR_ROUND_TRIP: 'selectedStoreDetailsForRoundTrip',
        SUCCESSFULLY_TRANSMITTED_QUOTE_ID: 'sucessfullyTransmittedQuoteId',
        BSR_PC_LIST: 'bsrPcList',
        ATP_STORES_CATSKU: 'atp_stores_catsku',
        IS_CREDIT_FULFILLMENT_SET: 'isCreditFulfillmentSet',
        CCA_SUBMISSION_ID: 'ccasubmissionid',
        CCA_VERIFICATION_CODE: 'ccaverificationcode',
        DATA_TO_FINALIZE_CALL: 'dataToFinalizeCall',
        REDIRECTED_TO_EDIT_FLOW: 'redirectedToEditFlow',
        MY_FAVORITES_DROPDOWN_DATA: 'myFavouritesDropdownData',
        P2P_LEFT_SIDE_NAV: 'leftSideNavigation',
        DISABLE_CURRENT_LOCATION: 'disableCurrentLocation',
        CUSTIDENT: 'custIdent',
        CCA_GLOBAL_ERROR: `cca_error`,
        IS_FIRST_CART_LOAD: 'isFirstCartLoad',
        QUOTE_DEFAULT_SELECTED_FIELDS: 'QuoteDefaultSelectedFields',
        COACHMARK_OBJ: 'coachmarkObj',
        IS_PRODUCT_FOR_COACHMARK_SELECTED: 'isProductForCoachmarkSelected',
        LOCALWISHLISTDATA: 'localWishListData',
        LOCAL_ASSETS_DATA: 'localAssetsData',
        IS_ALL_JOBSITE_FETCHED: 'isAllJobsitesFetched',
        GR_TOKEN: 'grToken',
        CHECKOUTUSERDETAILS: 'checkoutUserDetails',
        SELECTEDSTOREDATA: 'selectedStoreData',
        STARTDATESLOTS: 'startDateSlots',
        ENDDATESLOTS: 'endDateSlots',
        ISUSERDETAILSSET: 'isUserDetailsSet',
        GR_EMAIL: 'grEmail',
        ADDRESS_SELECTED: 'addressSelected',
        CART_ITEMS: 'cartItems',
        CLIENT_IP_ADDRESS: 'clientIpAddress',
        SALESREPID: 'salesRepId',
        ERS: 'ers',
        SFID: 'sfId',
        SESSIONID: 'sessionId',
        USER_EXISTS: 'userExists',
        USER_PHONE_VERIFIED: 'userPhoneVerified',
        DISCARD_OLD_CART: 'discardOldCart',
        IS_CAP_IN_EDIT_MODE: 'isCapInEditMode',
        PICKUPTIMESLOTS: 'pickupTimeSlots',
        RETURNTIMESLOTS: 'returnTimeSlots',
        CHECKOUT_LAST_UNFILLED_STEP: 'lastUnfilledStep',
        AUTHACCESSTOKEN: 'auth_access_token',
        SUBMISSION_ID: 'submissionid',
        REFERER: 'referer',
        AVS_RESPONSE: 'avsResponse',
        IS_ESTIMATES_LOADING: 'isEstimatesLoading',
        CART_ITEMS_AVAILABILITY_CHANGED_REASON: 'cartItemsAvailabilityChangedReason',
        SKIP_CONSUMABLES_ESTIMATES: 'skipConsumablesEstimates',
        SELECT_STORE_FROM_CONTEXT: 'selectStoreFromContext',
        SBMCH: 'SBMCH',
        PAYMENT_PREFERENCE_TYPE: 'paymentPreferenceType'
    },
    COOKIES: {
        CIF_MAGENTOTOKEN: 'cif.magentoToken',
        SBUID: 'sbuid',
        SBAID: 'sbaid',
        CIF_CART: 'cif.cart',
        ACCESS_TOKEN: 'access_token',
        REFRESH_TOKEN: 'refresh_token',
        SETTINGS: 'Settings',
        USERTYPE: 'userType',
        ACCESSTOKEN: 'accesstoken',
        COMPANYID: 'companyId',
        FIRSTNAME: 'firstName',
        REFRESHTOKEN: 'refreshtoken',
        SESSIONID: 'sessionid',
        GUESTSESSIONID: 'guestsessionid',
        LOGINTOKEN: 'loginToken',
        PUNCHOUT_REDIRECT_URL: 'punchout_redirect_url',
        TOKENEXPTIME: 'tokenExpTime',
        AUTHORITY_TYPE: 'authority_type',
        SBMCH: 'SBMCH',
        MY_SESSION_ASP: 'MY_SESSION_ASP',
        RENT_RESTRICTIONS_WARNING_MODAL_DISPLAYED: 'rentRestrictionsWarningModalDisplayed',
        PUNCHOUT_GROUP_ID:'punchout_group_id'
    }
};
